var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VLoadingRow",style:({
        height: _vm.height,
        width: _vm.width,
        marginBottom:_vm.mb
      })})
}
var staticRenderFns = []

export { render, staticRenderFns }